'use client';
import dynamic from 'next/dynamic';
import React from 'react';

const PublicHeader = dynamic(() => import('@letsgo/PublicHeader').then((m: any) => m.PublicHeader || m.default || m), { ssr: true });

export default function ClientHeader() {
  return <PublicHeader />;
}

